/**
 * v-phone: phone number inputs take numbers only, 11 digits (e.g. 08031234567), like the API requires.
 * Pasted "+234 803 123 4567" or "0803-123-4567" becomes 08031234567. The field turns red when it is left with
 * a number that isn't 11 digits. Works on <input> and on components whose root contains an input.
 */
function clean(value) {
  const raw = String(value == null ? "" : value);
  let digits = raw.replace(/\D+/g, "");
  if (digits.length === 13 && digits.startsWith("234")) digits = "0" + digits.slice(3);
  else if (digits.length === 14 && digits.startsWith("2340")) digits = digits.slice(3);
  else if (digits.length === 10 && /^[789]/.test(digits) && /^\s*\+?234|^\s*[789]/.test(raw)) digits = "0" + digits;
  return digits.slice(0, 11);
}

function inputOf(el) {
  return el.tagName === "INPUT" ? el : el.querySelector("input");
}

export function installPhoneInput(Vue) {
  Vue.directive("phone", {
    inserted(el) {
      const input = inputOf(el);
      if (!input) return;
      input.setAttribute("inputmode", "numeric");
      input.setAttribute("maxlength", "11");
      input.setAttribute("autocomplete", "tel");
      if (!input.getAttribute("placeholder")) input.setAttribute("placeholder", "e.g. 08031234567");
      input.title = "11 digits, numbers only (e.g. 08031234567)";
      const onInput = () => {
        // maxlength stops typing at 11, but a paste can carry +234…: clean the raw text first
        const value = clean(input.value);
        if (value !== input.value) {
          input.value = value;
          input.dispatchEvent(new Event("input", { bubbles: true })); // so v-model gets the cleaned number
        }
        if (value.length === 11 || value.length === 0) input.classList.remove("is-invalid");
      };
      const onPaste = (e) => {
        const text = (e.clipboardData || window.clipboardData).getData("text");
        if (!text) return;
        e.preventDefault();
        input.removeAttribute("maxlength");
        input.value = clean(text); // clean first so maxlength restore is safe
        input.setAttribute("maxlength", "11");
        input.dispatchEvent(new Event("input", { bubbles: true })); // always notify v-model
      };
      const onBlur = () => input.classList.toggle("is-invalid", input.value.length > 0 && input.value.length !== 11);
      input.addEventListener("input", onInput);
      input.addEventListener("paste", onPaste);
      input.addEventListener("blur", onBlur);
      el._phoneInput = { input, onInput, onPaste, onBlur };
    },
    unbind(el) {
      const h = el._phoneInput;
      if (!h) return;
      h.input.removeEventListener("input", h.onInput);
      h.input.removeEventListener("paste", h.onPaste);
      h.input.removeEventListener("blur", h.onBlur);
    },
  });
}
